export default __webpack_public_path__ + "static/media/Success.6d27b02e.svg";